export enum ApiStatus {
  /** 登录过期 */
  LoginExpired = -108,
  /** 需要进阶认证 */
  KycVerify1 = -151515,
  /** 需要高级认证 */
  KycVerify2 = -151516,
  /** 成功 */
  Success = 200,
  /** 网络超时 */
  Timeout = 504,
  /** 登录过期2 */
  LoginExpired2 = -118,
  /** 登录过期3 */
  LoginExpired3 = -119,
  /** 登录过期4 */
  LoginExpired4 = -105,
  /** 登录过期5 */
  LoginExpired5 = -106,
  /** 登录过期6 */
  LoginExpired6 = -107,
  /** 风险提示 */
  RiskWarning = -900200001,
  /** 禁止访问 */
  Forbidden = -900200002,
}

export const LoginExpiredStatusList = [
  ApiStatus.LoginExpired,
  ApiStatus.LoginExpired2,
  ApiStatus.LoginExpired3,
  ApiStatus.LoginExpired4,
  ApiStatus.LoginExpired5,
  ApiStatus.LoginExpired6,
]
